export default __webpack_public_path__ + "static/media/mint_bg.f1227629.png";